import { render, staticRenderFns } from "./KirmiziSantralChannelDetail.vue?vue&type=template&id=6e28ec12&scoped=true"
import script from "./KirmiziSantralChannelDetail.vue?vue&type=script&lang=js"
export * from "./KirmiziSantralChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./KirmiziSantralChannelDetail.vue?vue&type=style&index=0&id=6e28ec12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e28ec12",
  null
  
)

export default component.exports